import React from 'react';
import { useSelector } from 'react-redux';
import GamePage from './GamePage';
import UploadPuzzleGame from '../games/upload-puzzle/UploadPuzzleGame';
import BossCountsGame from '../games/boss-counts/BossCountsGame';
import FreedomGame from '../games/freedom/FreedomGame';
import { ACTIVE_GAMES, getActiveGame } from '../../utils/gameHelpers';

export default function GameRouter() {
  const { data: themeData, status } = useSelector((s) => s.theme);

  if (status === 'loading' || status === 'idle') {
    return (
      <div className="cg-page" style={{ padding: '2rem', textAlign: 'center' }}>
        Loading game…
      </div>
    );
  }

  const activeGame = getActiveGame(themeData);

  switch (activeGame) {
    case ACTIVE_GAMES.BADGES:
    case ACTIVE_GAMES.MENS_DAY:
      return <UploadPuzzleGame activeGame={activeGame} />;
    case ACTIVE_GAMES.BOSS_COUNTS:
      return <BossCountsGame />;
    case ACTIVE_GAMES.FREEDOM:
      return <FreedomGame />;
    case ACTIVE_GAMES.CHEERS:
    default:
      return <GamePage />;
  }
}
